import { Formik } from 'formik'
import { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Label,
  CardTitle,
  Button,
} from 'reactstrap'
import { login } from '../../api/auth'
import UserContext from '../../store/userContext'
import './login.scss'
const Login = () => {
  let initalValues = {
    username: '',
    password: '',
  }
  let history = useHistory()
  let userCtx = useContext(UserContext)

  const submitData = async (values) => {
    let userData = await login(values)
    if (userData) {
      userCtx.setEachData(userData)
      history.push('/home')
    }
  }
  
  return (
    <>
      <div className="login-container">
        <Card className="login-container__card">
          <CardTitle>Supervision Visit</CardTitle>
          <CardBody className="login-container__card__body">
            <Formik
              initialValues={initalValues}
              validate={(values) => {
                const errors = {}
                if (!values.username) errors.username = '** Required **'
                if (!values.password) errors.password = '** Required **'
                return errors
              }}
              onSubmit={(values) => submitData(values)}
            >
              {(formik) => (
                <Form onSubmit={formik.handleSubmit}>
                  <FormGroup>
                    <Label for="nameLabel">User Name</Label>
                    <Input
                      type="text"
                      name="username"
                      id="nameLabel"
                      placeholder="Enter your user name..."
                      onChange={formik.handleChange}
                      value={formik.values.username}
                    />
                    <span className="text-danger">
                      {formik.errors.username &&
                        formik.touched.username &&
                        formik.errors.username}
                    </span>
                  </FormGroup>
                  <FormGroup>
                    <Label for="passwordLabel">Password</Label>
                    <Input
                      type="password"
                      name="password"
                      id="passwordLabel"
                      placeholder="Enter your password..."
                      onChange={formik.handleChange}
                      value={formik.values.password}
                    />
                    <span className="text-danger">
                      {formik.errors.password &&
                        formik.touched.password &&
                        formik.errors.password}
                    </span>
                  </FormGroup>
                  <div class="text-center">
                    <Button color="primary" type="submit">
                      Login
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
      </div>
    </>
  )
}
export default Login
